import { render, staticRenderFns } from "./songs.vue?vue&type=template&id=3dcea404&scoped=true&"
import script from "./songs.vue?vue&type=script&lang=js&"
export * from "./songs.vue?vue&type=script&lang=js&"
import style0 from "./songs.vue?vue&type=style&index=0&id=3dcea404&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcea404",
  null
  
)

export default component.exports